import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { NotificationItem } from '@app/core/models';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class NotificationsApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/notifications`;

  getNotifications() {
    return this.http.get<NotificationItem[]>(this.baseUrl);
  }

  markAllRead() {
    return this.http.post<void>(`${this.baseUrl}/mark-all-read`, {});
  }

  markRead(notificationId: string) {
    return this.http.post<void>(`${this.baseUrl}/${notificationId}/mark-read`, {});
  }
}
